import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch, handleDateChangeEvent, handleDelete, handleDeleteWithoutClose, handlePatchWithoutClose } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { ClearAllButton } from '../../../common/table/ClearAllButton';

const formatKm = (value) => {
    if (!value) return value;
    return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
};

class CarKmHistory extends Component {

    state = {
        carKmHistories: [],
        licenseNumber: this.props.row.licenseNumber,
        selectedRow: null,
        toDelete: null,

        errors: new Map(),
    }

    componentDidMount() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    refresh() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    callApi = async () => {
        const response = await axios.get(`/api/carkm/${this.props.row.privateId}`);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CAR_KM_HISTORY";

            return item;
        })
        this.setState({ carKmHistories: data })
    }

    handleSubmit = async (event) => {
        // event.persist()
        event.preventDefault();
        const path = '/api/carkm';
        if (this.state.toDelete) {
            const requestObject = {
                "privateId": this.state.toDelete.privateId,
            };
            await handleDeleteWithoutClose(path, requestObject, this);
        } else {
            const requestObject = {
                "privateId": this.state.selectedRow.privateId,
                "carId": this.props.row.privateId,
                "licenseNumber": this.props.row.licenseNumber,
                "date": this.state.selectedRow.date,
                "km": this.state.selectedRow.km
            };
            await handlePatchWithoutClose(path, requestObject, this);
        }
        this.setState({ toDelete: null, selectedRow: null });
    };

    handleRowClick = (row, e) => {
        if (e.target.closest('.delete-button')) {
            this.handleDeleteClick(row, e);
            return;
        }
        if (this.state.selectedRow?.privateId !== row.privateId) {
            this.setState({ toDelete: null });
        }
        this.setState({ selectedRow: row }); // Use `date` or a unique identifier for selection
    };

    handleKmChange = (row, event) => {
        const { value } = event.target;
        const formattedValue = value.replace(/\D/g, '');
        const updatedRow = { ...this.state.selectedRow, km: formattedValue };
        this.setState({ selectedRow: updatedRow });
    };

    handleDeleteClick = (row, e) => {
        if (this.state.toDelete?.privateId === row.privateId) {
            this.setState({ toDelete: null });
        } else {
            this.setState({ toDelete: row });
        }
        e.stopPropagation();
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <table className="carkmhistory-table">
                    <thead>
                        <tr>
                            <th>Dátum</th>
                            <th>Km</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carKmHistories?.map((row) => (
                            <tr
                                key={row.privateId}
                                className={`carkmhistory-row ${this.state.selectedRow?.privateId === row.privateId ? "selected" : ""}  ${this.state.toDelete?.privateId === row.privateId ? "to-delete" : ""}`}
                                onClick={(e) => this.handleRowClick(row, e)}
                            >
                                <td className="date">{row.date}</td>
                                <td className="km">
                                    {this.state.selectedRow?.privateId === row.privateId ? (
                                        <>
                                            <input
                                                type="number"
                                                value={this.state.selectedRow.km}
                                                onChange={(e) => this.handleKmChange(row, e)}
                                                className="km-input"
                                            />
                                            <div className="delete-button"><ClearAllButton title="Km törlése" onClick={(e) => this.handleDeleteClick(row, e)} /></div>

                                        </>
                                    ) : (
                                        formatKm(row.km)
                                    )}
                                </td>
                            </tr>))
                        }
                    </tbody>
                </table>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        {this.state.toDelete ? "Töröl" : "Módosít"}
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(CarKmHistory);
